import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import OneTimeCheck from "./OneTimeCheck";
import Header from "../components/Header";
import MobileMenu from "../components/MobileMenu";
import Sidebar from "./Sidebar";
import ScrollToTop from "./ScrollToTop";

function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint in Tailwind
    };

    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkMobile);

    // Clean up
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (sidebarOpen) {
      setSidebarOpen(false);
    }
  }, [location]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen flex font-vazir">
      {/* Sidebar - hidden on mobile, shown on desktop */}
      <div className="hidden lg:block lg:w-64 lg:flex-shrink-0">
        <div className="sticky top-0 h-screen overflow-y-auto">
          <Sidebar />
        </div>
      </div>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={toggleSidebar}
          ></div>
          <div className="absolute inset-y-0 right-0 w-64 bg-white h-full sidebar-animate">
            <Sidebar />
          </div>
        </div>
      )}

      {/* Main content area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header toggleSidebar={toggleSidebar} />

        {/* Main content */}
        <main className="flex-1 overflow-x-hidden no-scrollbar font-vazir">
          <div className="py-4 container-custom">
            {/* 👇 Scroll reset happens here 👇 */}
            <ScrollToTop />
            <Outlet />
          </div>
        </main>

        {/* Mobile Menu - only visible on mobile */}
        {isMobile && (
          <div className="block lg:hidden">
            <MobileMenu />
          </div>
        )}
      </div>

      <OneTimeCheck />
    </div>
  );
}

export default Layout;
